import { takeLatest } from 'redux-saga/effects';
import { getPublishTerms, getPublishTermsCommercial } from './getPublishTerms';
import { LOAD_PUBLISH_TERMS, SELECT_PLACING_TYPE, SET_PLACING_MONEY_SOURCE } from '../../reducers';

export function* publishTermsSagas() {
  yield takeLatest([LOAD_PUBLISH_TERMS, SET_PLACING_MONEY_SOURCE], getPublishTerms);
}

export function* publishTermsCommercialSagas() {
  yield takeLatest([SELECT_PLACING_TYPE], getPublishTermsCommercial);
}

export * from './slideToSelectedService';
